export default {
    sysParamSelectParamValue: '/gscint/sys/sysParam/selectParamValue',
    sysParamSelectParamType: '/gscint/sys/sysParam/selectParamType',
    sysParamInsertParamType: '/gscint/sys/sysParam/insertParamType',
    sysParamUpdateParamType: '/gscint/sys/sysParam/updateParamTypeSelective',
    sysParamUpdateParamValue: '/gscint/sys/sysParam/updateParamValueSelective',
    sysParamInsertParamValue: '/gscint/sys/sysParam/insertParamValue',
};
